<template>
    <div :class="[$style['mds-stepper__list-item'], stepStatus]">
        <div :class="$style['mds-stepper__progress-track']"></div>
        <div :class="$style['mds-stepper__step']">
            <button
                type="button"
                :class="$style['mds-stepper__step-indicator']"
                :aria-disabled="status === 'disabled' || status === 'active' ? 'true' : 'false'"
            >
                <span :class="$style['mds-stepper__step-indicator-icon']">
                    <svg
                        v-if="status === 'active'"
                        :class="$style['mds-stepper__step-icon']"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 21 21"
                        fill="none"
                        focusable="false"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.5 19C15.1944 19 19 15.1944 19 10.5C19 5.80558 15.1944 2 10.5 2C5.80558 2 2 5.80558 2 10.5C2 15.1944 5.80558 19 10.5 19ZM10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z"
                            fill="#0077CF"
                        />
                        <circle cx="10.5" cy="10.5" r="5.5" fill="#0077CF" />
                    </svg>

                    <svg
                        v-else-if="status === 'complete'"
                        :class="$style['mds-stepper__step-icon']"
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        focusable="false"
                        viewBox="-0.044 0.062 9.211 8.841"
                    >
                        <path fill="none" stroke="#FFF" stroke-width="2" d="M.643 4.653L3.535 7.39 8.355.642"></path>
                    </svg>
                    <svg
                        v-else-if="status === 'warning'"
                        :class="$style['mds-stepper__step-icon']"
                        focusable="false"
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                    >
                        <circle cx="10.5" cy="10.5" r="10" fill="#1E1E1E" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM11.625 3.75V12.75H9.375V3.75H11.625ZM11.625 15V17.25H9.375V15H11.625Z"
                            fill="#F5C400"
                        />
                    </svg>
                </span>
                <span :class="$style['mds-stepper__step-label']">{{ title }}</span>
                <span :class="$style['mds-stepper__step-microcopy']" v-if="microcopy">{{ microcopy }}</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MdsStepperStep',
        props: {
            microcopy: {
                type: String,
                docs: {
                    validation: '—',
                    description: 'Sets the optional microcopy below the label.',
                },
            },
            status: {
                type: String,
                default: 'disabled',
                validator(value) {
                    return ['active', 'disabled', 'incomplete', 'complete', 'warning'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of:  `active`, `disabled`, `incomplete`, `complete`, `warning`.',
                    description: 'Sets the step status.',
                },
            },
            title: {
                type: String,
                required: true,
                docs: {
                    validation: '**Required**',
                    description: 'The title of the step',
                },
            },
        },
        computed: {
            stepStatus() {
                return this.$style[`mds-stepper__list-item--${this.status}`];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './step.scss';
</style>
